/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type UserAvatar_user$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobEventCancelation_event$ref: FragmentReference;
export type JobEventCancelation_event = {|
  +timestamp: any,
  +actor: {|
    +node: ?{|
      +name?: string,
      +$fragmentRefs: UserAvatar_user$ref,
    |}
  |},
  +$refType: JobEventCancelation_event$ref,
|};
*/


const node/*: ConcreteFragment*/ = {
  "kind": "Fragment",
  "name": "JobEventCancelation_event",
  "type": "JobEvent",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "timestamp",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "actor",
      "storageKey": null,
      "args": null,
      "concreteType": "JobEventActor",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "node",
          "storageKey": null,
          "args": null,
          "concreteType": null,
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "type": "User",
              "selections": [
                {
                  "kind": "ScalarField",
                  "alias": null,
                  "name": "name",
                  "args": null,
                  "storageKey": null
                },
                {
                  "kind": "FragmentSpread",
                  "name": "UserAvatar_user",
                  "args": null
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'b56768b3fc42735453b1f8612f5b5ee3';
module.exports = node;
